import Isotope from 'isotope-layout';
import 'isotope-packery';

window.addEventListener('load', function () {
    var grid = document.querySelectorAll('.gallery');
    if (grid.length < 1) {
        return false;
    }
    grid.forEach(function (item) {
        var iso = new Isotope(item, {
            itemSelector: '.gallery__item',
            layoutMode: 'packery',
            resize: true,
        });
        iso.layout();
    });
});
